import { hideMainErrorMessage, hideMainPaymentErrorMessage } from './checkout-shared';

const FORM_PAYMENT = 'form#payment';

// Modernized card-based payment picker only (.mod-payment-method-card): the page-level
// Continue button has nothing to submit until a new-method card or a saved payment radio
// is selected, so keep it hidden until one of those is chosen instead of letting the user
// click it and see a "Please select a payment method" error.
export function updatePaymentContinueButtonVisibility() {
    if($('.mod-payment-method-card').length === 0) return;
    const hasSelection = $('.mod-payment-method-card.is--selected').length > 0 ||
        $('.mod-saved-payments__radio:checked').length > 0;
    $('.checkout-next').toggle(hasSelection);
}

function showOnlyProviderButton($button) {
    const $providers = $('.payment__providers');
    $providers.show();
    $providers.children('div').hide();
    $button.closest($providers.children('div')).show();
}

function showProviderInlineModernized($button) {
    $('#saveCc, #savePayment').prop('checked', false);
    $('.mod-payment-selection').hide();
    showOnlyProviderButton($button);
    $('#btnCancelPaypalFlow').show();
}

function cancelPaypalInlineFlow() {
    $('.payment__providers').hide();
    $('#btnCancelPaypalFlow').hide();
    $('.mod-payment-selection').show();
    $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
    $('#paymentChanged').val('false');
    updatePaymentContinueButtonVisibility();
}

const PAYMENT_METHOD_HANDLER_MAP = {
    cc: () => {
        if($('#btnCreditCard').length) {
            $('#btnCreditCard').trigger('click');
        }
        // Adding a new card is a separate flow from picking a saved one - checkout.js's
        // changePaymentMethod() already re-shows this list when backing out.
        $('.mod-saved-payments').hide();
    },
    paypal: () => {
        $('#saveCc, #savePayment').prop('checked', false);
        if($('.mod-payment-method-card').length > 0) {
            if($('#paypal-card-overlay iframe').length === 0) {
                showProviderInlineModernized($('#paypal-button'));
            }
        } else {
            $('.payment__providers').show();
            $(FORM_PAYMENT).data('payment-type', 'paypal');
        }
    },
    sepa: () => {
        if($('.mod-payment-method-card').length > 0) {
            // Use the header-row's own "Change Payment Method" link (already aligned next to
            // the "Payment" heading) instead of showProviderInlineModernized()'s
            // #btnCancelPaypalFlow, which lives outside the header row and renders on its own
            // stacked/misaligned line for SEPA.
            $('.mod-payment-selection').hide();
            $('.mod-payment-selection__change-wrap').show();
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-sepa').length) {
            $('#btn-sepa').trigger('click');
        }
        // Hide the "Add SEPA" trigger button once the mod-sepa form is shown - it has
        // no visibility condition of its own in onSepaButtonClick() for modernized
        // (that only fires for allFlowIsEnabled, legacy-only flows), so it would
        // otherwise stay visible above the form, unlike the Figma design.
        $('.payment__providers').hide();
        // Adding SEPA is a separate flow from picking a saved card - checkout.js's
        // changePaymentMethod() already re-shows this list when backing out.
        $('.mod-saved-payments').hide();
    },
    ideal: () => {
        if($('.mod-payment-method-card').length > 0) {
            // Same fix as SEPA above: use the header-row's own "Change Payment Method" link
            // instead of showProviderInlineModernized()'s #btnCancelPaypalFlow, which renders
            // on its own stacked/misaligned line below "Payment" instead of same-row-aligned.
            $('.mod-payment-selection').hide();
            $('.mod-payment-selection__change-wrap').show();
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-ideal').length) {
            $('#btn-ideal').trigger('click');
        }
        // Hide the "Add iDEAL" trigger button (and its oversized, unstyled logo image) once
        // the mod-ideal info block is shown - onIDealButtonClick() only hides
        // .payment__providers for allFlowIsEnabled (legacy-only) flows, so it would otherwise
        // stay visible above the new info block, same issue already fixed for SEPA above.
        $('.payment__providers').hide();
        // Adding iDEAL is a separate flow from picking a saved card - checkout.js's
        // changePaymentMethod() already re-shows this list when backing out.
        $('.mod-saved-payments').hide();
    },
    bancontact: () => {
        if($('.mod-payment-method-card').length > 0) {
            // Same fix as SEPA/iDeal above: use the header-row's own "Change Payment Method"
            // link instead of showProviderInlineModernized()'s #btnCancelPaypalFlow, which
            // renders on its own stacked/misaligned line below "Payment" instead of
            // same-row-aligned.
            $('.mod-payment-selection').hide();
            $('.mod-payment-selection__change-wrap').show();
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-bancontact').length) {
            $('#btn-bancontact').trigger('click');
        }
        // Hide the "Add Bancontact" trigger button once the mod-bancontact info block is
        // shown - onBancontactButtonClick() only hides .payment__providers for
        // allFlowIsEnabled (legacy-only) flows, same issue already fixed for SEPA/iDeal above.
        $('.payment__providers').hide();
        // Adding Bancontact is a separate flow from picking a saved card - checkout.js's
        // changePaymentMethod() already re-shows this list when backing out.
        $('.mod-saved-payments').hide();
    },
    applepay: () => {
        const $applePayBtn = $('.apple-pay-button');
        if($applePayBtn.length) {
            $applePayBtn.trigger('click');
        }
    },
    venmo: () => {
        if($('.mod-payment-method-card').length > 0) {
            const $providers = $('.payment__providers');
            $providers.css({ position: 'absolute', left: '-9999px', visibility: 'hidden' }).show();
            $providers.children('div').hide();
            $('#venmo-button').closest($providers.children('div')).show();
            const $venmoBtn = $('#venmo-button');
            if($venmoBtn.length) {
                $venmoBtn.trigger('click');
            }
            $providers.hide().css({ position: '', left: '', visibility: '' });
        } else {
            $('.payment__providers').show();
            const $venmoBtn = $('#venmo-button');
            if($venmoBtn.length) {
                $venmoBtn.trigger('click');
            }
        }
    },
    isawallet: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-isawallet'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-isawallet').length) {
            $('#btn-isawallet').trigger('click');
        }
    },
    cash: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-cash'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-cash').length) {
            $('#btn-cash').trigger('click');
        }
    },
    debitcard: () => {
        if($('.mod-payment-method-card').length > 0) {
            showProviderInlineModernized($('#btn-debitcard'));
        } else {
            $('.payment__providers').show();
        }
        if($('#btn-debitcard').length) {
            $('#btn-debitcard').trigger('click');
        }
    }
};

function onPaymentMethodCardClick(event) {
    const $card = $(this);
    const method = $card.data('payment-method');

    // The real (invisible) Braintree button overlay is a descendant of this card, so a click
    // that actually lands on it still bubbles up and fires this same handler - without this
    // check, that click would ALSO run the normal handler below and show the intermediate
    // "Change payment method / PayPal button" screen behind/underneath the SDK's own popup,
    // which is the "still shows this UI" behavior being fixed here. When the click genuinely
    // landed on the overlay, let the SDK's own button handle opening the popup and stop here.
    if(event && event.target && $(event.target).closest('#paypal-card-overlay').length) {
        $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
        $card.addClass('is--selected').attr('aria-pressed', 'true');
        updatePaymentContinueButtonVisibility();
        return;
    }

    $('.payment__providers').hide();
    $('#btnCancelPaypalFlow').hide();
    $('.mod-payment-method-card').removeClass('is--selected').attr('aria-pressed', 'false');
    $card.addClass('is--selected').attr('aria-pressed', 'true');

    hideMainErrorMessage();
    hideMainPaymentErrorMessage();
    updatePaymentContinueButtonVisibility();

    const handler = PAYMENT_METHOD_HANDLER_MAP[method];
    if(typeof handler === 'function') {
        handler();
    }
}

// The iDEAL Terms and Conditions CMS content renders as one plain-text run
// ("Note: Using iDEAL | Wero..."); Figma calls for "Note:" to stay bold (the
// element's own default weight) while the rest of the sentence is regular -
// wrap everything after the leading "Note:" in .mod-ideal__note-rest so CSS
// can drop just that part back to normal weight, without touching CMS content.
function formatIdealNoteEmphasis() {
    $('.mod-ideal__note:not([id])').each(function() {
        const $note = $(this);
        if($note.data('note-emphasis-applied')) return;
        const $textHost = $note.find('span').last().length ? $note.find('span').last() : $note;
        const html = $textHost.html();
        const match = html && html.match(/^(\s*[^:<]*:\s*)/);
        if(!match) return;
        const prefix = match[1];
        const rest = html.slice(prefix.length);
        $textHost.html(`${prefix}<span class="mod-ideal__note-rest">${rest}</span>`);
        $note.data('note-emphasis-applied', true);
    });
}

// Braintree renders a real PayPal iframe into the card's overlay asynchronously; the SDK
// itself is responsible for making its own placeholder frame clickable once ready.

export function initModernizedPaymentMethodCards() {
    if(!$('.checkout-v2').length) return;

    const $cards = $('.mod-payment-method-card');
    if($cards.length === 0) return;
    if($cards.filter(function() { return $(this).data('checkout-modernized-bound') === true; }).length > 0) return;

    $('.payment__providers').hide();
    $cards.each(function() {
        $(this).data('checkout-modernized-bound', true);
    });
    $cards.on('click.checkoutModernized', onPaymentMethodCardClick);
    // Cards are role="button" divs (not real <button>s, see cshtml comment) so keyboard
    // activation isn't native - fire the same click handler on Enter/Space.
    $cards.on('keydown.checkoutModernized', function(e) {
        if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });
    $('#btnCancelPaypalFlow').off('click.checkoutModernized').on('click.checkoutModernized', cancelPaypalInlineFlow);
}

$(function() {
    if($('.checkout-v2').length) {
        initModernizedPaymentMethodCards();
        formatIdealNoteEmphasis();
    }
});
